export {default} from './RecordScreen.connect';
